export const HERO_GRADIENT = "linear(115deg, #16344E 0%, #234E70 55%, #2E6690 100%)";
